var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5949 1.25013H1.87476C0.835367 1.21044 0.835367 2.79031 1.87476 2.75063H11.5562C12.5767 2.79031 12.6164 1.25013 11.5959 1.25013H11.5949ZM1.87476 7.25024C0.875053 7.25024 0.875053 8.7498 1.87476 8.7498H7.35518C8.37567 8.7498 8.37567 7.25024 7.35518 7.25024H1.87476ZM1.87476 13.2504C0.875053 13.2504 0.875053 14.7499 1.87476 14.7499H14.1556C15.1553 14.7499 15.1553 13.2504 14.1556 13.2504H1.87476Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1b02f224f8981230922acb620d5dba21.svg";
export { ForwardRef as ReactComponent };